<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Create User
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card>
      <validation-observer
        ref="userCreateForm"
        #default="{invalid}"
      >
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col cols="md-6">
              <b-form-group
                label="Name*"
                label-for="h-user-name"
                label-cols-md="3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="h-user-name"
                    v-model="name"
                    placeholder="Name"
                    :state="(errors.length > 0 || nameValidation) ? false : null"
                    name="name"
                    @input="nameValidation == true ? nameValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="nameValidation"
                    class="text-danger"
                  >
                    {{ nameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Position*"
                label-for="h-user-position"
                label-cols-md="3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Position"
                  vid="position"
                  rules="required"
                >
                  <b-form-input
                    id="h-user-position"
                    v-model="position"
                    placeholder="Position"
                    :state="(errors.length > 0 || positionValidation) ? false : null"
                    name="position"
                    @input="positionValidation == true ? positionValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="positionValidation"
                    class="text-danger"
                  >
                    {{ positionError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <validation-provider
                #default="{ errors }"
                name="Department"
                vid="department"
                rules="required"
              >
                <b-form-group
                  label="Department*"
                  label-for="h-user-department"
                  label-cols-md="3"
                  :state="(errors.length > 0 || departmentValidation) ? false : null"
                >
                  <v-select
                    id="h-user-department"
                    v-model="department"
                    label="name"
                    placeholder="Choose a Department"
                    multiple
                    :options="departments"
                    :reduce="name => name._id"
                    :clearable="false"
                    @input="departmentValidation == true ? departmentValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="departmentValidation"
                    class="text-danger"
                  >
                    {{ departmentError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Email*"
                label-for="h-user-email"
                label-cols-md="3"
                description="Only email addresses on official Nirvana domain names are accepted."
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="h-user-email"
                    v-model="email"
                    v-b-tooltip.hover.top="'Allowed domains: @nirvana.com.sg, @nvasia.com.sg, @nvasia.com.my, @linsan.sg, @kiansengculinary.com'"
                    placeholder="Email"
                    :state="(errors.length > 0 || emailValidation) ? false : null"
                    name="email"
                    @input="emailValidation == true ? emailValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="emailValidation"
                    class="text-danger"
                  >
                    {{ emailError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Password*"
                label-for="h-user-password"
                label-cols-md="3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required|min:6"
                >
                  <b-form-input
                    id="h-user-password"
                    v-model="password"
                    placeholder="Password"
                    :state="(errors.length > 0 || passwordValidation) ? false : null"
                    name="password"
                    @input="passwordValidation == true ? passwordValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="passwordValidation"
                    class="text-danger"
                  >
                    {{ passwordError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-9">
              <validation-provider
                #default="{ errors }"
                name="Roles"
                vid="roles"
                rules="required"
              >
                <b-form-group
                  label="Roles*"
                  label-for="h-user-roles"
                  label-cols-md="2"
                  :state="(errors.length > 0 || roleValidation) ? false : null"
                >
                  <!-- <v-select
                    id="h-user-roles"
                    v-model="roles"
                    label="role"
                    multiple
                    :options="roleOptions"
                    :reduce="role => role._id"
                    @input="roleValidation == true ? roleValidation = false : null"
                  /> -->

                  <b-form-tags
                    v-model="roles"
                    size="lg"
                    add-on-change
                    no-outer-focus
                  >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                      <ul
                        v-if="tags.length > 0"
                        class="list-inline d-inline-block mb-1"
                      >
                        <li
                          v-for="tag in tags"
                          :key="tag"
                          class="list-inline-item"
                        >
                          <b-form-tag
                            :title="tag"
                            :disabled="disabled"
                            variant="danger"
                            @remove="removeTag(tag)"
                          >
                            {{ resolveRoleName(tag) }}
                          </b-form-tag>
                        </li>
                      </ul>
                      <b-form-select
                        v-bind="inputAttrs"
                        v-on="inputHandlers"
                      >
                        <template v-slot:first>
                          <!-- This is required to prevent bugs with Safari -->
                          <option
                            disabled
                            value=""
                          >
                            Choose a Role....
                          </option>
                        </template>
                        <option
                          v-for="(role, ind) in roleOptions"
                          :key="ind"
                          :value="role._id"
                        >
                          {{ role.role }}
                        </option>
                      </b-form-select>
                    </template>
                  </b-form-tags>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="roleValidation"
                    class="text-danger"
                  >
                    {{ roleError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-6">
              <validation-provider
                #default="{ errors }"
                name="Status"
                vid="status"
                rules="required"
              >
                <b-form-group
                  label="Status*"
                  label-for="h-user-status"
                  label-cols-md="3"
                  :state="(errors.length > 0 || statusValidation) ? false : null"
                >
                  <v-select
                    id="h-user-status"
                    v-model="status"
                    label="title"
                    :options="option"
                    :reduce="title => title.code"
                    :clearable="false"
                    @input="statusValidation == true ? statusValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="statusValidation"
                    class="text-danger"
                  >
                    {{ statusError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-6" />
          </b-row>

          <b-nav class="wrap-border save-nav">
            <li
              class="nav-item ml-auto"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="flat-primary"
                :to="{ name: 'directory-users-index' }"
              >
                Cancel
              </b-button>
            </li>
            <li
              class="nav-item mr-1"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                :disabled="invalid"
              >
                <feather-icon
                  icon="SaveIcon"
                  class="mr-50"
                />
                <span class="align-middle">Save User</span>
              </b-button>
            </li>
          </b-nav>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BFormTags, BFormTag, BFormSelect, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required, min } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BFormTags,
    BFormTag,
    BFormSelect,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      name: '',
      position: '',
      department: [],
      email: '',
      password: '',
      status: 'active',
      roles: [],
      nameError: 'Valid name is required',
      nameValidation: false,
      positionError: 'Valid position is required',
      positionValidation: false,
      departmentError: 'Valid department is required',
      departmentValidation: false,
      emailError: 'Valid email is required',
      emailValidation: false,
      passwordError: 'Valid password is required',
      passwordValidation: false,
      roleError: 'Valid role is required',
      roleValidation: false,
      statusError: 'Valid status is required',
      statusValidation: false,
      option: [{ title: 'Active', code: 'active' }, { title: 'Inactive', code: 'inactive' }],
      roleOptions: [],
      departments: [],

      // validation rules
      required,
      min,
    }
  },
  beforeMount() {
    this.$http.get('directory/users/respond-with/extra-options')
      .then(response => {
        this.roleOptions = response.data.roleOptions ?? []
        this.departments = response.data.departments ?? []

        // this.department = [this.departments[0]._id]
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    resolveRoleName(role) {
      const type = this.roleOptions.find(o => o._id === role)
      if (type) {
        return type.role
      }
      return ''
    },
    submitForm() {
      this.$refs.userCreateForm.validate().then(success => {
        if (success) {
          const formData = new FormData()

          formData.append('name', this.name)
          formData.append('position', this.position)
          // formData.append('department', this.department)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.department.length; i++) {
            formData.append('department[]', this.department[i])
          }
          formData.append('email', this.email)
          formData.append('password', this.password)
          formData.append('status', this.status)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.roles.length; i++) {
            formData.append('roles[]', this.roles[i])
          }
          this.$http.post('directory/users/store', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message ?? '',
                  icon: 'BellIcon',
                  variant: 'success',
                },
              })
              this.$router.push({ name: 'directory-users-index' })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'name') {
                    this.nameError = validationError.msg
                    this.nameValidation = true
                  } else if (validationError.param === 'position') {
                    this.positionError = validationError.msg
                    this.positionValidation = true
                  } else if (validationError.param === 'department') {
                    this.departmentError = validationError.msg
                    this.departmentValidation = true
                  } else if (validationError.param === 'email') {
                    this.emailError = validationError.msg
                    this.emailValidation = true
                  } else if (validationError.param === 'password') {
                    this.passwordError = validationError.msg
                    this.passwordValidation = true
                  } else if (validationError.param === 'roles') {
                    this.roleError = validationError.msg
                    this.roleValidation = true
                  } else if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
